import { render, staticRenderFns } from "./PageNav.vue?vue&type=template&id=9faef36a&scoped=true&"
import script from "./PageNav.vue?vue&type=script&lang=ts&"
export * from "./PageNav.vue?vue&type=script&lang=ts&"
import style0 from "./PageNav.vue?vue&type=style&index=0&id=9faef36a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9faef36a",
  null
  
)

export default component.exports